import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { CollectionStore, CollectionState } from './collection.store';

@Injectable({ providedIn: 'root' })
export class CollectionQuery extends QueryEntity<CollectionState> {
	constructor(protected store: CollectionStore) {
		super(store);
	}
}
